<template>
  <div id="ShareButton">
    <a @click="openShareMenu()">
      <ShareIcon v-if="!$root.shareOpen"/>
      <div class="close-button" v-if="$root.shareOpen">
        <span class="close-button--bar"></span>
        <span class="close-button--bar"></span>
      </div>
    </a>
  </div>
</template>
<script>
import ShareIcon from '../assets/share.svg'
import CloseIcon from '../assets/close.svg'
export default {
  name: 'ShareButton',
  components: {
    ShareIcon,
    CloseIcon
  },
  methods: {
    openShareMenu () {
      this.$root.menuOpen = true
      this.$root.shareOpen = !this.$root.shareOpen
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
a {
  display: block;
  width: 22px;
  cursor: pointer;
}
svg {
  fill: $white;
}
#app.belowhero, #app.menu-opened {
  svg {
    fill: #C1C1C3;
  }
}
.close-button {
  cursor: pointer;
  height: 25px;
  .close-button--bar {
    display: block;
    width: 25px;
    height: 2px;
    margin-top: 3px;
    background: #C1C1C3;
    &:nth-child(1) {
      transform: translate(0, 10px) rotate(45deg);
    }
    &:nth-child(2) {
      transform: translate(0, 4px) rotate(-45deg) ;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareButton.vue